import React from "react";
import { IconButton as ChakraIconButton } from "@chakra-ui/react";
import { IconButtonProps as ChakraIconButtonProps } from "@chakra-ui/button/dist/types/icon-button";

interface IProps extends ChakraIconButtonProps {
  id: string;
}

export interface IconButtonProps extends ChakraIconButtonProps {}

// forwarRef potrzebny w przypadku kiedy trzeba oddać częściową kontrolę rodzicowi, tak jest w przypadku ToolTipa
const IconButton = React.forwardRef<HTMLButtonElement, IProps>((props, ref) => {
  return <ChakraIconButton {...props} ref={ref} />;
});

export { IconButton };
